// SEO constants kept separate so they can be imported by both the SEO
// component and (later) a Next.js metadata helper.
import { SITE_NAME, SITE_URL, SITE_DESCRIPTION } from "@/data/site";
import { IMAGES } from "@/data/content";

export { SITE_NAME, SITE_URL, SITE_DESCRIPTION };

/** Default OpenGraph/Twitter share image. */
export const IMAGES_OG = IMAGES.hero;
